import type { ThemeV3 } from '../types/themeTypes';

export const paperTheme: ThemeV3 = {
  id: 'Paper',
  name: 'Paper',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': 'oklch(0.985 0.006 75deg)',
    'surface-1': 'oklch(0.98875 0.0045 75deg)',
    'surface-2': 'oklch(0.9925 0.003 75deg)',
    'surface-3': 'oklch(0.99625 0.0015 75deg)',
    'surface-4': 'oklch(1 0 75deg)',
    'content-0': 'oklch(0.22 0.008 70deg)',
    'content-1': 'oklch(0.4 0.007 70deg)',
    'content-2': 'oklch(0.52 0.006 70deg)',
    'content-3': 'oklch(0.62 0.005 70deg)',
    'content-4': 'oklch(0.72 0.004 70deg)',
    edge: 'oklch(85.92% 0.0135 75)',
    'edge-muted': 'oklch(90.67% 0.0089 75)',
    accent: 'oklch(0.5 0.13 250deg)',
    red: 'oklch(62.51% 0.2414 25.33)',
    orange: 'oklch(70.86% 0.2077 47.6)',
    amber: 'oklch(78.71% 0.1661 70.08)',
    yellow: 'oklch(83.13% 0.1532 86.05)',
    lime: 'oklch(67.19% 0.1467 130.9)',
    green: 'oklch(64.14% 0.1655 149.6)',
    teal: 'oklch(66.2% 0.1453 182.5)',
    cyan: 'oklch(70.49% 0.1294 215.2)',
    blue: 'oklch(0.5 0.13 259.815deg)',
    violet: 'oklch(54.32% 0.1603 292.7)',
    purple: 'oklch(32.76% 0.2243 303.9)',
    pink: 'oklch(64.14% 0.1929 354.3)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'oklch(55.37% 0.2379 250)',
    'link-hover': 'oklch(72.02% 0.119 250)',
    'link-visited': 'oklch(60.16% 0.2119 294)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-3) 98%, var(--color-content-0))',
  },
};
